import { render, staticRenderFns } from "./PermissionsCard.vue?vue&type=template&id=02893308&scoped=true"
import script from "./PermissionsCard.vue?vue&type=script&lang=js"
export * from "./PermissionsCard.vue?vue&type=script&lang=js"
import style0 from "./PermissionsCard.vue?vue&type=style&index=0&id=02893308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02893308",
  null
  
)

export default component.exports